import { render, staticRenderFns } from "./SubContentTemplate.vue?vue&type=template&id=080c0134"
import script from "./SubContentTemplate.vue?vue&type=script&lang=js"
export * from "./SubContentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports